import React, { useEffect, useState } from 'react';
import { DirectionsBus, Assessment } from '@mui/icons-material';
import { lerpColor } from '../utils';

function ReportSummary(props) {
  let day = {
    day: '',
    dayList: [],
  };
  let allDays = [];

  const carData = props.carData;
  const rawData = props.rawData;
  const pointJson = props.pointJson;
  const chartData = props.chartData;

  const sliced = chartData.slice(1, chartData.length);

  function calculateAverage(arr) {
    let sum = [];
    let res = 0;
    arr.forEach((element) => {
      if (
        typeof element !== 'undefined' &&
        element !== null &&
        !isNaN(element)
      ) {
        sum.push(element);
      }
    });
    sum.length > 0 ? (res = sum.reduce((a, b) => a + b)) : (res = null);
    if (res !== null) {
      return res / sum.length;
    }
    return res;
  }

  sliced.forEach((item) => {
    // console.log(item);
    day.day = item[0];
    // console.log(day);

    item.forEach((item2) => {
      if (
        item2 !== null &&
        item2 !== undefined &&
        typeof item2 !== 'string' &&
        !isNaN(item2)
      ) {
        // console.log(typeof NaN);
        day.dayList.push(item2);
      }
    });

    // console.log(day);
    allDays.push(day);
    day = {
      day: '',
      dayList: [],
    };
  });

  return (
    <div className="text-[#2e4665] w-full">
      <div className=" w-full flex justify-evenly items-center mt-4">
        <div className="flex flex-col w-full justify-center gap-3 items-center">
          <span className="font-bold text-[16px] underline-offset-4 underline">
            En Yüksek Skorlu Araç
          </span>
          <div className="flex justify-evenly items-center gap-2">
            <span className="text-[20px]">{carData[0]?.plate} </span>
            <span
              className="p-1 font-bold"
              style={{
                background: lerpColor(carData[0]?.score),
                color: 'white',
              }}
            >
              {carData[0]?.score ? '%' + carData[0]?.score : '(-)'}
            </span>
          </div>
        </div>
        <div className="flex flex-col w-full justify-center gap-3 items-center">
          <span className="font-bold text-[16px] underline-offset-4 underline">
            Filo Güvenlik Ortalaması{' '}
          </span>
          <span
            className="p-1 font-bold"
            style={{
              background: lerpColor(carData[0]?.score),
              color: 'white',
            }}
          >
            {pointJson?.weeklyScore ? '%' + pointJson?.weeklyScore : '(-)'}
          </span>
        </div>
        <div className="flex flex-col w-full justify-center gap-3 items-center">
          <span className="font-bold text-[16px] underline-offset-4 underline">
            En Düşük Skorlu Araç{' '}
          </span>
          <div className="flex justify-evenly items-center gap-2">
            <span className="text-[20px]">
              {carData[carData.length - 1]?.plate}{' '}
            </span>
            <span
              className="p-1 font-bold"
              style={{
                background: lerpColor(carData[carData.length - 1]?.score),
                color: 'white',
              }}
            >
              {carData[carData.length - 1]?.score
                ? '%' + carData[carData.length - 1]?.score
                : '(-)'}
            </span>
          </div>
        </div>
      </div>

      <div className=" w-full flex  flex-wrap justify-evenly items-center mt-4">
        {allDays.map((item, i) => {
          return (
            <div
              key={i}
              className="flex flex-col justify-center gap-3 items-center  w-36 p-3 rounded-md border-2 border-black"
            >
              <span className="font-bold text-lg underline-offset-4 underline">
                {item.day}
              </span>
              <div className="flex justify-between items-center w-full">
                <DirectionsBus sx={{ color: '#2e4665' }} />
                <span className="font-bold">{item.dayList.length}</span>
              </div>
              <div className="flex justify-between items-center w-full ">
                <Assessment sx={{ color: '#2e4665' }} />
                <span
                  className="font-bold p-1"
                  style={{
                    background: lerpColor(
                      calculateAverage(item.dayList)?.toFixed(2),
                    ),
                    color: calculateAverage(item.dayList)?.toFixed(2)
                      ? 'white'
                      : 'black',
                  }}
                >
                  {calculateAverage(item.dayList)?.toFixed(2)
                    ? '%' + calculateAverage(item.dayList)?.toFixed(2)
                    : '(-)'}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <div className=" w-full flex justify-evenly items-center mt-4">
        <div className="flex w-full justify-center gap-3 items-center">
          <DirectionsBus sx={{ color: '#2e4665' }} />
          <span className="text-[16px]">Görev Yapan Araç Sayısı</span>
        </div>
        <div className="flex w-full justify-center gap-3 items-center">
          <Assessment sx={{ color: '#2e4665' }} />
          <span className="text-[16px]">Ortalama Gün Skoru</span>
        </div>
      </div>
    </div>
  );
}

export default ReportSummary;
